import {DesignScreen} from '../../../stores/DesignScreen';
import {SplittedDesignSubscreen} from './Subscreen';

export class SplittedDesignScreen extends DesignScreen {
    screens;

    constructor(screen, name) {
        super(screen, name);
        this.screens = [];
    }

    get isSplitted() {
        return true;
    }

    setCollection(screen) {
        this.screens.push(
            new SplittedDesignSubscreen(
                {
                    title: screen.subtitles[0],
                    entityName: screen.entityName,
                    hiddenEntityName: screen.hiddenEntityName
                },
                'FRST',
                this
            )
        );
        this.screens[0].setCollection({fields: screen.fields[0]});
        this.screens.push(
            new SplittedDesignSubscreen(
                {
                    title: screen.subtitles[1],
                    entityName: screen.entityName,
                    hiddenEntityName: screen.hiddenEntityName
                },
                'SCND',
                this
            )
        );
        this.screens[1].setCollection({fields: screen.fields[1]});
    }

    checkReloadNeeded(screensStore) {
        if (!screensStore.isReloadNeeded && this.changed) {
            screensStore.isReloadNeeded = true;
        }
    }

    get allFields() {
        return this.screens[0].collection.fields.concat(this.screens[1].collection.fields);
    }

    setChanged(value) {
        this.screens[0].setChanged(value);
        this.screens[1].setChanged(value);
    }

    get changed() {
        return this.screens[0].changed || this.screens[1].changed;
    }

    checkReloadNeededOnRestore(screensStore) {
        screensStore.isReloadNeeded = true;
    }
}
